export default __webpack_public_path__ + "static/MobileScribble-029563c4ba12c64c832b5448a9b9763b.svg";